import { supplierListQuerySchema, type SupplierInput } from '@chukua/common';
import { useDirectoryList } from '../../../hooks/use-directory-list';
import { useDirectoryMutations } from '../../../hooks/use-directory-mutations';
import { createSupplier, deactivateSupplier, listSuppliers, reactivateSupplier, updateSupplier, type SupplierView } from '../suppliers.api';

/** The supplier directory (`useDirectoryList`) plus create, edit, deactivate and reactivate. `afterChange` refreshes what a change can alter elsewhere: the catalogue a save may have added to. */
export function useSuppliers(afterChange: () => Promise<unknown>) {
  const { state, list, isRefreshing, reload } = useDirectoryList(supplierListQuerySchema, listSuppliers);
  const mutations = useDirectoryMutations<SupplierInput, SupplierView>(
    { create: createSupplier, update: updateSupplier, deactivate: deactivateSupplier, reactivate: reactivateSupplier },
    async () => {
      await reload();
      await afterChange();
    },
  );

  return { state, list, isRefreshing, ...mutations };
}
